import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
const HomeSlider = () => {
  return (
    <>
      <div className="slider-sec">
      <div
        id="homeCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
        data-bs-pause="false"
      >
          <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide0.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide1.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide2.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide3.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide4.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide5.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide6.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide7.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide8.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              <img
                src="https://webapi.entab.info/api/image/CSFL/public/images/slide9.jpg"
                className="d-block w-100"
                alt="Cannosa school"
              />
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#homeCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#homeCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>

          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
